/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { AuthenticationService } from '@/services/authentication.service';
import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class LogoutAction
 *
 * @brief trigger a logout
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class LogoutAction extends Action {

  private auth: AuthenticationService = null;

  constructor(options: any = null) {

    super({
      key:   'user.logout',
      type:  ActionType.User_Logout,
      label: 'Logout',
      icon:  '<i class="fas fa-sign-out-alt"></i>',
      tip:   'Sign off from this tool'
    });

    this.auth     = this.injector().get(AuthenticationService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[LogoutAction] logging out...');

    this.auth.logout();
  }
}
